import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "intervenant-item" }
const _hoisted_2 = { class: "intervenant-header" }
const _hoisted_3 = { class: "avatar-column" }
const _hoisted_4 = { class: "info-column" }
const _hoisted_5 = { class: "intervenant-name" }
const _hoisted_6 = {
  key: 0,
  class: "contact-info"
}
const _hoisted_7 = {
  key: 0,
  class: "contact-item"
}
const _hoisted_8 = {
  key: 1,
  class: "contact-item"
}
const _hoisted_9 = { class: "budget-overview" }
const _hoisted_10 = { class: "budget-metrics" }
const _hoisted_11 = { class: "metric budget-metric" }
const _hoisted_12 = { class: "metric-content" }
const _hoisted_13 = { class: "metric-label" }
const _hoisted_14 = { class: "metric-value budget" }
const _hoisted_15 = { class: "metric consumed-metric" }
const _hoisted_16 = { class: "metric-content" }
const _hoisted_17 = { class: "metric-label" }
const _hoisted_18 = { class: "metric-value consumed" }
const _hoisted_19 = { class: "metric remaining-metric" }
const _hoisted_20 = { class: "metric-content" }
const _hoisted_21 = { class: "metric-label" }
const _hoisted_22 = { class: "progress-timeline-row" }
const _hoisted_23 = { class: "consumption-progress" }
const _hoisted_24 = { class: "progress-header" }
const _hoisted_25 = { class: "progress-label" }
const _hoisted_26 = {
  key: 0,
  class: "expense-timeline"
}
const _hoisted_27 = { class: "timeline-header" }
const _hoisted_28 = { class: "timeline-count" }
const _hoisted_29 = {
  key: 0,
  class: "timeline-sample-info"
}
const _hoisted_30 = { class: "timeline-visual" }
const _hoisted_31 = { class: "timeline-track" }
const _hoisted_32 = ["title"]
const _hoisted_33 = {
  key: 0,
  class: "dot-importance-indicator"
}
const _hoisted_34 = { class: "dot-date-label" }
const _hoisted_35 = ["title"]
const _hoisted_36 = { class: "overflow-count" }
const _hoisted_37 = ["title"]
const _hoisted_38 = {
  key: 0,
  class: "dot-importance-indicator"
}
const _hoisted_39 = { class: "dot-date-label" }
const _hoisted_40 = {
  key: 0,
  class: "timeline-actions"
}
const _hoisted_41 = { class: "all-transactions-modal" }
const _hoisted_42 = { class: "modal-header-info" }
const _hoisted_43 = { class: "transaction-count" }
const _hoisted_44 = { class: "transactions-table" }
const _hoisted_45 = { class: "table" }
const _hoisted_46 = { class: "amount-cell" }

import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatDate, formatPercentage } from '@/utils/formatters';
import { formatCurrencyWithUserPreference } from '@/utils/currencyUtils';
import ProgressBar from 'primevue/progressbar';
import Avatar from 'primevue/avatar';
import Modal from '@/components/base/Modal.vue';

interface Props {
  intervenant: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'IntervenantBudgetCard',
  props: {
    intervenant: {}
  },
  setup(__props: any) {

// @ts-ignore
const props = __props;

const { t } = useI18n();

// Local state
const isExpanded = ref(false);
const showAllTransactionsModal = ref(false);
const formattedBudget = ref<string>('');
const formattedConsumed = ref<string>('');
const formattedRemaining = ref<string>('');
const formattedTransactions = ref<Record<string, string>>({});

// Methods
const getInitials = (name: string | undefined) => {
  if (!name) return '';
  return name
    .split(' ')
    .slice(0, 2)
    .map((word: string) => word.charAt(0).toUpperCase())
    .join('');
};

const getIntervenantColor = (intervenantId: number) => {
  const colors = [
    '#667eea', '#764ba2', '#f093fb', '#f5576c',
    '#4facfe', '#00f2fe', '#43e97b', '#38f9d7',
    '#ffecd2', '#fcb69f', '#a8edea', '#fed6e3',
    '#ff9a9e', '#fecfef', '#ffecd2', '#fcb69f'
  ];
  return colors[intervenantId % colors.length];
};

const getProgressBarClass = (percentage: number | undefined) => {
  return 'progress-dynamic';
};

const getProgressBarStyle = (percentage: number | undefined) => {
  const normalizedPercentage = Math.min(Math.max(percentage || 0, 0), 100);
  
  let backgroundColor;
  if (normalizedPercentage === 0) {
    backgroundColor = '#ff4757';
  } else if (normalizedPercentage <= 20) {
    backgroundColor = '#ff6b35';
  } else if (normalizedPercentage <= 40) {
    backgroundColor = '#ffa502';
  } else if (normalizedPercentage <= 60) {
    backgroundColor = '#ffdd59';
  } else if (normalizedPercentage <= 80) {
    backgroundColor = '#7bed9f';
  } else if (normalizedPercentage < 100) {
    backgroundColor = '#2ed573';
  } else {
    backgroundColor = '#2ed573';
  }
  
  return {
    '--progress-color': backgroundColor
  };
};

const getPercentageClass = (percentage: number | undefined) => {
  const normalizedPercentage = Math.min(Math.max(percentage || 0, 0), 100);
  
  if (normalizedPercentage >= 80) return 'high-usage';
  if (normalizedPercentage >= 60) return 'medium-usage'; 
  if (normalizedPercentage >= 40) return 'medium-low-usage';
  if (normalizedPercentage >= 20) return 'low-medium-usage';
  return 'low-usage';
};

const toggleExpanded = () => {
  isExpanded.value = !isExpanded.value;
};

const showAllTransactions = () => {
  showAllTransactionsModal.value = true;
};

const closeAllTransactionsModal = () => {
  showAllTransactionsModal.value = false;
};

const getSampledTransactions = (transactions: any[] | undefined) => {
  if (!transactions || transactions.length === 0) {
    return { sampled: [], hasMore: false, hiddenCount: 0 };
  }

  const MAX_VISIBLE_TRANSACTIONS = 5;
  
  if (transactions.length <= MAX_VISIBLE_TRANSACTIONS) {
    return {
      sampled: transactions.map((transaction, index) => ({
        transaction,
        originalIndex: index,
        isImportant: false
      })),
      hasMore: false,
      hiddenCount: 0
    };
  }

  const sortedByAmount = [...transactions]
    .map((transaction: any, index: number) => ({ transaction, originalIndex: index }))
    .sort((a: any, b: any) => (b.transaction.amount || 0) - (a.transaction.amount || 0));

  const sortedByDate = [...transactions]
    .map((transaction: any, index: number) => ({ transaction, originalIndex: index }))
    .sort((a: any, b: any) => new Date(b.transaction.transactionDate).getTime() - new Date(a.transaction.transactionDate).getTime());

  const mustInclude = new Set();
  
  mustInclude.add(sortedByDate[0].originalIndex);
  mustInclude.add(sortedByDate[sortedByDate.length - 1].originalIndex);
  mustInclude.add(sortedByAmount[0].originalIndex);
  
  if (MAX_VISIBLE_TRANSACTIONS > 3) {
    if (sortedByAmount.length > 1) {
      mustInclude.add(sortedByAmount[1].originalIndex);
    }
    
    const middleIndex = Math.floor(sortedByDate.length / 2);
    mustInclude.add(sortedByDate[middleIndex].originalIndex);
  }

  const selectedIndices = Array.from(mustInclude).slice(0, MAX_VISIBLE_TRANSACTIONS) as number[];

  const sampled = selectedIndices
    .sort((a: number, b: number) => a - b)
    .map((originalIndex: number) => ({
      transaction: transactions[originalIndex],
      originalIndex,
      isImportant: originalIndex === sortedByAmount[0].originalIndex
    }));

  return {
    sampled,
    hasMore: transactions.length > MAX_VISIBLE_TRANSACTIONS,
    hiddenCount: transactions.length - sampled.length
  };
};

const isLargestTransaction = (transaction: any, allTransactions: any[]) => {
  if (!allTransactions || allTransactions.length === 0) return false;
  const maxAmount = Math.max(...allTransactions.map((t: any) => t.amount || 0));
  return (transaction.amount || 0) === maxAmount;
};

const getTimelineDotPosition = (index: number, totalDots: number) => {
  if (totalDots === 1) {
    return { left: '50%' };
  }
  const percentage = (index / (totalDots - 1)) * 100;
  return { 
    left: `${Math.max(0, Math.min(100, percentage))}%`,
    transform: 'translateX(-50%)'
  };
};

const getTimelineDotClass = (index: number, totalDots: number, isImportant = false) => {
  const classes = ['timeline-dot'];
  
  if (isImportant) classes.push('important-transaction');
  
  if (index === 0) classes.push('first-dot');
  if (index === totalDots - 1) classes.push('last-dot');
  if (index === Math.floor(totalDots / 2)) classes.push('middle-dot');
  
  if (totalDots > 10) classes.push('dense-timeline');
  if (totalDots <= 3) classes.push('sparse-timeline');
  
  return classes.join(' ');
};

const formatDateAmount = (transaction: any) => {
    const date = formatShortDate(transaction.transactionDate);
  // Try to get formatted amount by id first, then by index
  let amount = '...';
  if (transaction.id && formattedTransactions.value[String(transaction.id)]) {
    amount = formattedTransactions.value[String(transaction.id)];
  } else {
    // Find transaction by reference in the array
    const transactions = props.intervenant.expenseTransactions || [];
    const index = transactions.findIndex((t: any) => t === transaction);
    if (index !== -1) {
      amount = formattedTransactions.value[`index-${index}`] || 
               formattedTransactions.value[String(transaction.id)] || '...';
    }
  }
  return `${date} - ${amount}`;
};

const formatTransactionTooltip = (transaction: any) => {
  const date = formatDate(transaction.transactionDate);
  // Try to get formatted amount by id first, then by index
  let amount = '...';
  if (transaction.id && formattedTransactions.value[String(transaction.id)]) {
    amount = formattedTransactions.value[String(transaction.id)];
  } else {
    // Find transaction by reference in the array
    const transactions = props.intervenant.expenseTransactions || [];
    const index = transactions.findIndex((t: any) => t === transaction);
    if (index !== -1) {
      amount = formattedTransactions.value[`index-${index}`] || 
               formattedTransactions.value[String(transaction.id)] || '...';
    }
  }
  const description = transaction.description || t('reports.noDescription');
  return `${date}\nAmount: ${amount}\nDescription: ${description}`;
};

const formatShortDate = (date: string | undefined) => {
  if (!date) return '';
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString(undefined, { 
    month: 'short', 
    day: 'numeric' 
  });
};

const formatAmounts = async () => {
  try {
    formattedBudget.value = await formatCurrencyWithUserPreference(props.intervenant.totalBudgetAllocated);
    formattedConsumed.value = await formatCurrencyWithUserPreference(props.intervenant.totalConsumedAmount);
    formattedRemaining.value = await formatCurrencyWithUserPreference(props.intervenant.totalRemainingAmount);
    
    if (props.intervenant.expenseTransactions?.length) {
      const transactionAmounts: Record<string, string> = {};
      for (let i = 0; i < props.intervenant.expenseTransactions.length; i++) {
        const transaction = props.intervenant.expenseTransactions[i];
        // Use both transaction.id and index as fallback
        const key = transaction.id ? String(transaction.id) : `index-${i}`;
        transactionAmounts[key] = await formatCurrencyWithUserPreference(transaction.amount);
      }
      formattedTransactions.value = transactionAmounts;
    }
  } catch (err) {
    console.warn('Error formatting currency:', err);
    formattedBudget.value = props.intervenant.totalBudgetAllocated?.toString() || '0';
    formattedConsumed.value = props.intervenant.totalConsumedAmount?.toString() || '0';
    formattedRemaining.value = props.intervenant.totalRemainingAmount?.toString() || '0';
  }
};

watch(() => props.intervenant, formatAmounts, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Avatar), {
          label: getInitials(_ctx.intervenant.intervenantName),
          shape: "circle",
          size: "large",
          class: "intervenant-avatar",
          style: _normalizeStyle({ backgroundColor: getIntervenantColor(_ctx.intervenant.intervenantId) })
        }, null, 8, ["label", "style"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.intervenant.intervenantName), 1),
        (_ctx.intervenant.email || _ctx.intervenant.phone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.intervenant.email)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "pi pi-envelope" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.intervenant.email), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.intervenant.phone)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "pi pi-phone" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.intervenant.phone), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "metric-icon budget" }, [
            _createElementVNode("i", { class: "pi pi-wallet" })
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('reports.totalBudget')), 1),
            _createElementVNode("span", _hoisted_14, _toDisplayString(formattedBudget.value || '...'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "metric-icon consumed" }, [
            _createElementVNode("i", { class: "pi pi-chart-pie" })
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('reports.consumed')), 1),
            _createElementVNode("span", _hoisted_18, _toDisplayString(formattedConsumed.value || '...'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            class: _normalizeClass(["metric-icon remaining", { 'negative': _ctx.intervenant.totalRemainingAmount < 0 }])
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "pi pi-chart-line" }, null, -1)
          ]))], 2),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('reports.remaining')), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["metric-value remaining", { 'negative': _ctx.intervenant.totalRemainingAmount < 0 }])
            }, _toDisplayString(formattedRemaining.value || '...'), 3)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('reports.consumption.percentage')), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["progress-text", getPercentageClass(_ctx.intervenant.totalConsumptionPercentage)])
            }, _toDisplayString(_unref(formatPercentage)(_ctx.intervenant.totalConsumptionPercentage)), 3)
          ]),
          _createVNode(_unref(ProgressBar), {
            value: Math.min(_ctx.intervenant.totalConsumptionPercentage || 0, 100),
            class: _normalizeClass([getProgressBarClass(_ctx.intervenant.totalConsumptionPercentage), "modern-progress"]),
            style: _normalizeStyle(getProgressBarStyle(_ctx.intervenant.totalConsumptionPercentage))
          }, null, 8, ["value", "class", "style"])
        ]),
        (_ctx.intervenant.expenseTransactions && _ctx.intervenant.expenseTransactions.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "pi pi-calendar" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('reports.expenseTimeline')), 1),
                _createElementVNode("small", _hoisted_28, [
                  _createTextVNode(" (" + _toDisplayString(_ctx.intervenant.expenseTransactions.length) + " " + _toDisplayString(_ctx.$t('reports.transactions')) + ") ", 1),
                  (getSampledTransactions(_ctx.intervenant.expenseTransactions).sampled.length < _ctx.intervenant.expenseTransactions.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, " - " + _toDisplayString(_ctx.$t('reports.showing')) + " " + _toDisplayString(getSampledTransactions(_ctx.intervenant.expenseTransactions).sampled.length), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "timeline-line" }, null, -1)),
                  (!isExpanded.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSampledTransactions(_ctx.intervenant.expenseTransactions).sampled, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `transaction-${item.originalIndex}`,
                            class: "timeline-dot-container",
                            style: _normalizeStyle(getTimelineDotPosition(index, getSampledTransactions(_ctx.intervenant.expenseTransactions).sampled.length))
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["timeline-dot", getTimelineDotClass(index, getSampledTransactions(_ctx.intervenant.expenseTransactions).sampled.length, item.isImportant)]),
                              title: formatTransactionTooltip(item.transaction)
                            }, [
                              (item.isImportant)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_32),
                            _createElementVNode("div", _hoisted_34, _toDisplayString(formatDateAmount(item.transaction)), 1)
                          ], 4))
                        }), 128)),
                        (getSampledTransactions(_ctx.intervenant.expenseTransactions).hasMore)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "timeline-overflow-indicator",
                              title: _ctx.$t('reports.moreTransactions', { count: getSampledTransactions(_ctx.intervenant.expenseTransactions).hiddenCount }),
                              onClick: showAllTransactions
                            }, [
                              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "pi pi-ellipsis-h" }, null, -1)),
                              _createElementVNode("span", _hoisted_36, "+" + _toDisplayString(getSampledTransactions(_ctx.intervenant.expenseTransactions).hiddenCount), 1)
                            ], 8, _hoisted_35))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.intervenant.expenseTransactions, (transaction, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `transaction-full-${index}`,
                          class: "timeline-dot-container",
                          style: _normalizeStyle(getTimelineDotPosition(index, _ctx.intervenant.expenseTransactions.length))
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["timeline-dot", getTimelineDotClass(index, _ctx.intervenant.expenseTransactions.length, isLargestTransaction(transaction, _ctx.intervenant.expenseTransactions))]),
                            title: formatTransactionTooltip(transaction)
                          }, [
                            (isLargestTransaction(transaction, _ctx.intervenant.expenseTransactions))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_37),
                          _createElementVNode("div", _hoisted_39, _toDisplayString(formatDateAmount(transaction)), 1)
                        ], 4))
                      }), 128))
                ])
              ]),
              (_ctx.intervenant.expenseTransactions.length > 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["timeline-toggle-btn", { active: isExpanded.value }]),
                      onClick: toggleExpanded
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(isExpanded.value ? 'pi pi-eye-slash' : 'pi pi-eye')
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(isExpanded.value ? _ctx.$t('reports.showLess') : _ctx.$t('reports.showAll')), 1)
                    ], 2)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(Modal, {
      show: showAllTransactionsModal.value,
      title: _ctx.$t('reports.allTransactions'),
      size: "large",
      onClose: closeAllTransactionsModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.intervenant.intervenantName), 1),
            _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.intervenant.expenseTransactions?.length || 0) + " " + _toDisplayString(_ctx.$t('reports.transactionCount')), 1)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("table", _hoisted_45, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('reports.transactions.date')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('reports.transactions.amount')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('reports.transactions.description')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.intervenant.expenseTransactions, (transaction, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: transaction.id || index,
                    class: _normalizeClass({ 'important-row': isLargestTransaction(transaction, _ctx.intervenant.expenseTransactions) })
                  }, [
                    _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(transaction.transactionDate)), 1),
                    _createElementVNode("td", _hoisted_46, [
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'largest-amount': isLargestTransaction(transaction, _ctx.intervenant.expenseTransactions) })
                      }, _toDisplayString(formattedTransactions.value[transaction.id ? String(transaction.id) : `index-${index}`] || '...'), 3)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(transaction.description || _ctx.$t('reports.noDescription')), 1)
                  ], 2))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "title"])
  ]))
}
}

})